import { ReactSketchCanvas, ReactSketchCanvasRef } from 'react-sketch-canvas';
import { useRef, useState, CSSProperties } from 'react'
import { IconSave, IconClear } from '../img'
import { getAutoValue } from '../data/Help';

const CanvasCtrl = ({ id,
    value,
    onChange,
    preserveBackgroundImageAspectRatio = 'xMidYMax'
}: ICanvasCtrl) => {
    let inputRef = useRef<ReactSketchCanvasRef>(null);
    const [isModified, setIsModified] = useState(false);
    const [useCanva, setUseCanva] = useState(false);

    const styles: CSSProperties = {
        backgroundOrigin:'border-box'
    };

    const clear = (e: any) => {
        e.preventDefault();
        onChange(id, getAutoValue(id.replace('img', '')) ?? '', false);
        inputRef.current?.resetCanvas();
        setUseCanva(false)
    }
    const undo = (e: any) => {
        e.preventDefault();
        inputRef.current?.undo();
    }

    const saveImg = async (e: any) => {
        e.preventDefault();
        if (useCanva) {
            let img = await inputRef.current?.exportImage('png');
            onChange(id, img ?? '', true);
            inputRef.current?.resetCanvas();
            setUseCanva(false)
        }
    }

    const readOnly = (value: boolean): CSSProperties => ({ readOnly: value } as CSSProperties);

    const changeHandler = async () => {
        setUseCanva(true);
    }

    return (
        <>
            <div style={{ display: 'flex', justifyContent: '' }}>
                <button className='icon-canvas' onClick={clear}><IconClear /></button>
                <button className='icon-canvas ml-10' onClick={saveImg} style={readOnly(!isModified)}><IconSave /></button>
            </div>

            <ReactSketchCanvas
                id={id}
                style={styles}
                width='100%'
                height="200"
                strokeWidth={3}
                canvasColor='#000'
                strokeColor="#008866"
                backgroundImage={value}
                exportWithBackgroundImage={false}
                ref={inputRef}
                //preserveBackgroundImageAspectRatio='xMidYMin meet'
                preserveBackgroundImageAspectRatio={preserveBackgroundImageAspectRatio}

                className='mt-20'
                onChange={changeHandler}
            />
        </>
    )
}

export { CanvasCtrl }